import { Injectable } from '@angular/core';
import { CryptoService } from '@desbank/core/src/lib/services/crypto';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
    private cryptoService: CryptoService
  ) {}

  public getSession(key: string): any {
    const sessionItem = sessionStorage.getItem(key);

    if (!sessionItem) {
      return null;
    }

    return JSON.parse(this.cryptoService.decrypt(sessionItem, key));
  }

  public setSession(key: string, arr: any): void {
    const sessionItem = sessionStorage.getItem(key);

    if (sessionItem) {
      sessionStorage.removeItem(key);
    }

    sessionStorage.setItem(key, this.cryptoService.encrypt(JSON.stringify(arr), key));
  }

  public removeSession(key: string): void {
    sessionStorage.removeItem(key);
  }

  public cleanAllSessions(): void {
    sessionStorage.clear();
  }
}
